export default {
    'ExcelsiorLT': { 
        'fontFamily': 'ExcelsiorLT',
        'fontWeight': 'normal',
        'fontStyle': 'normal'
    },
    'ExcelsiorLTItalic': { 
        'fontFamily': 'ExcelsiorLT-Italic',
        'fontWeight': 'normal',
        'fontStyle': 'normal',
    }
}


// WEBPACK FOOTER //
// ./src/Constants/fonts.ts